const createInitalState = () => {
  let state = {
    type: undefined,
    header: undefined,
    content: undefined,
    hidden: true,
  };
  return state;
};

export const INITIAL_STATE = createInitalState();

export const SHOW_INFO_MESSAGE = "unido-web/flash-message/SHOW_INFO_MESSAGE";
export const SHOW_WARNING_MESSAGE =
  "unido-web/flash-message/SHOW_WARNING_MESSAGE";
export const SHOW_SUCCESS_MESSAGE =
  "unido-web/flash-message/SHOW_SUCCESS_MESSAGE";
export const SHOW_ERROR_MESSAGE = "unido-web/flash-message/SHOW_ERROR_MESSAGE";
export const RESET_MESSAGE = "unido-web/flash-message/RESET_MESSAGE";

const flashMessageReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SHOW_INFO_MESSAGE:
      return {
        ...state,
        type: "info",
        header: action.header,
        content: action.content,
        hidden: false,
      };
    case SHOW_WARNING_MESSAGE:
      return {
        ...state,
        type: "warning",
        header: action.header,
        content: action.content,
        hidden: false,
      };
    case SHOW_SUCCESS_MESSAGE:
      return {
        ...state,
        type: "positive",
        header: action.header,
        content: action.content,
        hidden: false,
      };
    case SHOW_ERROR_MESSAGE:
      return {
        ...state,
        type: "negative",
        header: action.header,
        content: action.content,
        hidden: false,
      };
    case RESET_MESSAGE:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default flashMessageReducer;

export const showInfoMessage = (header, content) => {
  return {
    type: SHOW_INFO_MESSAGE,
    header: header,
    content: content,
  };
};

export const showWarningMessage = (header, content) => {
  return {
    type: SHOW_WARNING_MESSAGE,
    header: header,
    content: content,
  };
};

export const showSuccessMessage = (header, content) => {
  return {
    type: SHOW_SUCCESS_MESSAGE,
    header: header,
    content: content,
  };
};

export const showErrorMessage = (header, content) => {
  return {
    type: SHOW_ERROR_MESSAGE,
    header: header,
    content: content,
  };
};

export const resetMessage = () => {
  return {
    type: RESET_MESSAGE,
  };
};
